import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import "../../App.css";
import Listdelete from "./ListDelete";

import Add from "./Add";

const baseURL = process.env.REACT_APP_API_JOBS;

function BhinaMembers(props) {
  const { visible, meeting, id } = props;
  const [counter, setCounter] = useState(0);
  const [members, setMembers] = useState([]);
  const [roles, setRoles] = useState([]);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMembers = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "memberlist/", {
          signal: controller.signal,
        });
        setMembers(response.data.filter((member) => member.active));
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    const getData2 = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "nazeegtype/", {
          signal: controller.signal,
        });
        setRoles(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getMembers();
    getData2();
  }, []);

  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible || meeting == null) return;
  return (
    <>
      <div
        style={{
          height: "calc(100vh - 40px)",
          overflowY: "scroll",
        }}
      >
        <Add
          increment={increment}
          counter={counter}
          meeting={meeting}
          roles={roles}
          members={members}
        />

        <Listdelete
          increment={increment}
          counter={counter}
          setCounter={setCounter}
          meeting_id={meeting.id}
          roles={roles}
          members={members}
        />
      </div>
    </>
  );
}

export default BhinaMembers;
